import { CaseDataManagerSchema, CaseTemplate } from 'dashboard/models/case-template';
import Action from 'lib/interfaces/Action';

export type CaseTemplateActions =
  | Action<CaseTemplateActionType.ClearCaseTemplate>
  | Action<CaseTemplateActionType.SetCaseTemplate, SetCaseTemplatePayload>
  | Action<CaseTemplateActionType.SetCaseDataManagerSchema, SetCaseDataManagerSchemaPayload>;

export enum CaseTemplateActionType {
  ClearCaseTemplate = 'case-template/CLEAR_CASE_TEMPLATE',
  SetCaseTemplate = 'case-template/SET_CASE_TEMPLATE',
  SetCaseDataManagerSchema = 'case-template/SET_CASE_DATA_MANAGER_SCHEMA',
}

export function clearCaseTemplate(): Action<CaseTemplateActionType.ClearCaseTemplate> {
  return { type: CaseTemplateActionType.ClearCaseTemplate };
}

interface SetCaseTemplatePayload {
  caseTemplate: CaseTemplate;
}

export function setCaseTemplate(
  caseTemplate: CaseTemplate,
): Action<CaseTemplateActionType.SetCaseTemplate, SetCaseTemplatePayload> {
  return {
    payload: {
      caseTemplate,
    },
    type: CaseTemplateActionType.SetCaseTemplate,
  };
}

interface SetCaseDataManagerSchemaPayload {
  caseDataManagerSchema: CaseDataManagerSchema;
}

export function setCaseDataManagerSchema(
  caseDataManagerSchema: CaseDataManagerSchema,
): Action<CaseTemplateActionType.SetCaseDataManagerSchema, SetCaseDataManagerSchemaPayload> {
  return {
    payload: {
      caseDataManagerSchema,
    },
    type: CaseTemplateActionType.SetCaseDataManagerSchema,
  };
}
